
import { Component, Vue, Prop } from 'vue-property-decorator';
import { stockNameObject } from '@/types/stockName';
import { STAT } from '@/config/config';
@Component
export default class CommonRankName extends Vue {
  @Prop() private option!: stockNameObject;
  @Prop() private stat!: string;
  postStat() {
    const page = this.$route.name === 'rank' ? STAT.rank : STAT.homeRecommend;
    this.stat && window.hxmClickStat(`${page}.${this.stat}`);
  }
}
